<template>
  <div class="training-yearly-plan-filter-bar">
    <v-row no-gutters class="ma-0">
      <v-col cols="12" sm="6" md="4" lg="3" class="px-2 py-0">
        <v-select
          v-model="localFilters.categoryIds"
          :items="categories"
          item-text="name"
          item-value="id"
          multiple
          clearable
          dense
          hide-details
          menu-props="bottom, offsetY"
          :label="$t('wkt.admin.training-action.yearly-plan.filters.category')"
          @change="emitFilters"
          @click:clear="emitFilters"
        />
      </v-col>

      <v-col cols="12" sm="6" md="4" lg="3" class="px-2 py-0">
        <v-select
          v-model="localFilters.statuses"
          :items="statusOptions"
          item-text="label"
          item-value="id"
          multiple
          clearable
          dense
          hide-details
          menu-props="bottom, offsetY"
          :label="$t('wkt.admin.training-action.yearly-plan.filters.status')"
          @change="emitFilters"
          @click:clear="emitFilters"
        />
      </v-col>

      <v-col cols="12" sm="6" md="4" lg="3" class="px-2 py-0">
        <v-select
          v-model="localFilters.modes"
          :items="modeOptions"
          item-text="label"
          item-value="id"
          multiple
          clearable
          dense
          hide-details
          menu-props="bottom, offsetY"
          :label="$t('wkt.admin.training-action.yearly-plan.filters.mode')"
          @change="emitFilters"
          @click:clear="emitFilters"
        />
      </v-col>

      <v-col cols="12" sm="6" md="4" lg="3" class="px-2 py-0 d-flex align-center">
        <v-checkbox
          v-model="localFilters.showCanceled"
          class="mt-0 pt-0"
          dense
          hide-details
          :label="$t('wkt.admin.training-action.yearly-plan.filters.show-canceled')"
          @change="emitFilters"
        />
      </v-col>
    </v-row>

  </div>
</template>

<script>

export default {
  name: "TrainingYearlyPlanFilters",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    categories: {
      type: Array,
      default: () => [],
    },
    statusOptions: {
      type: Array,
      default: () => [],
    },
    modeOptions: {
      type: Array,
      default: () => [],
    },
    filters: {
      type: Object,
      default: () => ({
        categoryIds: [],
        statuses: [],
        modes: [],
        showCanceled: false,
      }),
    },
  },
  data() {
    return {
      localFilters: this.cloneFilters(this.filters),
    };
  },
  watch: {
    filters: {
      deep: true,
      handler(newValue) {
        this.localFilters = this.cloneFilters(newValue);
      },
    },
  },
  methods: {
    cloneFilters(filters) {
      return {
        categoryIds: filters && Array.isArray(filters.categoryIds) ? [...filters.categoryIds] : [],
        statuses: filters && Array.isArray(filters.statuses) ? [...filters.statuses] : [],
        modes: filters && Array.isArray(filters.modes) ? [...filters.modes] : [],
        showCanceled: !!(filters && filters.showCanceled),
      };
    },
    emitFilters() {
      this.$emit("change", this.cloneFilters(this.localFilters));
    },
  },
};
</script>
